class PasFlagship extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.video = this.querySelector('[data-flagship-video]');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.sectionVisible = false;
    this.classList.add('is-enhanced');

    this.onVisibilityChange = () => this.syncPlayback();
    this.onMotionChange = () => this.syncPlayback();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.reducedMotion.addEventListener?.('change', this.onMotionChange);

    if (this.video) {
      this.onPlaying = () => this.classList.add('is-video-active');
      this.onPause = () => this.classList.remove('is-video-active');
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.onPause);
    }

    if ('IntersectionObserver' in window) {
      this.revealObserver = new IntersectionObserver(([entry]) => {
        if (!entry?.isIntersecting) return;
        this.classList.add('is-revealed');
        this.revealObserver.disconnect();
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      this.revealObserver.observe(this);

      this.playbackObserver = new IntersectionObserver(([entry]) => {
        this.sectionVisible = Boolean(entry?.isIntersecting);
        this.syncPlayback();
      }, { threshold: 0.15 });
      this.playbackObserver.observe(this);
    } else {
      this.sectionVisible = true;
      this.classList.add('is-revealed');
      this.syncPlayback();
    }
  }

  disconnectedCallback() {
    this.revealObserver?.disconnect();
    this.playbackObserver?.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.reducedMotion?.removeEventListener?.('change', this.onMotionChange);
    this.video?.removeEventListener('playing', this.onPlaying);
    this.video?.removeEventListener('pause', this.onPause);
    this.video?.pause();
  }

  syncPlayback() {
    if (!this.video) return;
    const shouldPlay = this.sectionVisible && !document.hidden && !this.reducedMotion.matches;
    if (shouldPlay) this.video.play().catch(() => this.classList.remove('is-video-active'));
    else this.video.pause();
  }
}

if (!customElements.get('pas-flagship')) customElements.define('pas-flagship', PasFlagship);
